<button
  mat-button
  class="marketing-btn"
  color="primary"
  [ngClass]="marketBtnSize"
  (click)="onClick($event)"> {{text}}</button>
